import { render, staticRenderFns } from "./joinLogistics.vue?vue&type=template&id=6affd6f6&scoped=true&"
import script from "./joinLogistics.vue?vue&type=script&lang=js&"
export * from "./joinLogistics.vue?vue&type=script&lang=js&"
import style0 from "./joinLogistics.vue?vue&type=style&index=0&id=6affd6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affd6f6",
  null
  
)

export default component.exports